<script>
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import ModalTitle from 'root/services/modals/ModalTitle.modal.svelte';
  import {notificationUtils, mainAPI} from 'root/angular-injector-provider';
  import TextArea from 'root/components/molecules/inputs/TextArea.labeled.svelte'
  import {PUBLIC} from 'root/messaging/messaging-const';
  import {updateReadMessages} from 'root/messaging/user-messaging.store';

  export let hide, bidsIds;

  const conversationType = PUBLIC;

  let newMessage = '';

  async function sendMessage(){
    if(newMessage && newMessage.trim()){
      const ar = await notificationUtils().onSave(() => saveMessagesAndUpdateUnread());
      hide(ar);
    }

    async function saveMessagesAndUpdateUnread(){
      const actionReport = await mainAPI().messaging.sendMessages(bidsIds, conversationType, newMessage);
      await updateReadMessages();
      return actionReport;
    }
  }

</script>

<ClosableModal close="{hide}" width="{'600px'}">
  <div slot="heading">
    <ModalTitle title="Send Message">
      Send message to {bidsIds.length} hotels.
    </ModalTitle>
  </div>

  <div class="NewMessageForm">
    <div class="NewMessageTextArea">
        <TextArea bind:value="{newMessage}"
                  placeholder="Type Your Message..."
                  maxLength="1000"
                  maxHeight="200px"
        >
          Message:
        </TextArea>
    </div>
    <button class="aBtn asLarge asMain atLight SendMessage" on:click={sendMessage}>Send</button>
  </div>
</ClosableModal>

<style lang="stylus">
  .NewMessageForm {
    display: flex;
    padding: 20px;
    align-items: flex-end;
    margin-top: -30px;
  }

  .NewMessageTextArea {
    flex: 1 1 100%;
    padding-right: 10px;
  }

  button.SendMessage {
    align-self: flex-end;
  }
</style>
